import { useNavigate } from 'react-router-dom';
import PackageImportDialog from '../../PackageImportDialog';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { useSsoReauth } from '../../contexts/SsoReauthContext';
import { showToastError } from '../../components/ToastNotifications';
import { getAvailablePackages } from '../../hooks/usePackages';
import { usePackagesWizard } from './PackagesWizardContext';
import { getEndpointErrorMessage } from '../../utils/requestErrors';

export default function PackageImportContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();
  const { handleSsoError } = useSsoReauth();
  const {
    resetPackageImportWizard,
    setPackageCandidates,
    setPackageImportSelection,
  } = usePackagesWizard();

  return (
    <PackageImportDialog
      organizationId={Number(org?.id) || undefined}
      onClose={() => {
        resetPackageImportWizard();
        navigate('/packages', { replace: true });
      }}
      onNext={async ({ market, facility, metrcFacilityId, marketName, facilityName }) => {
        if (!org?.id) {
          return;
        }

        try {
          const available = await getAvailablePackages({
            organizationId: org.id,
            marketId: market,
            facilityId: facility,
            includeImported: false,
            page: 0,
            pageSize: 12,
          });

          if (available?.documents?.length) {
            setPackageImportSelection({ market, facility, marketName, facilityName, metrcFacilityId });
            setPackageCandidates(available.documents.map((item) => ({ ...item, selected: false })));
            navigate('/packages/import/select', { replace: true });
          } else {
            showToastError('No available packages found for this facility');
          }
        } catch (error) {
          console.error(error);
          if (handleSsoError(error, { returnTo: '/packages/import' })) return;
          showToastError(getEndpointErrorMessage(
            error,
            'Error trying to obtain available packages',
          ));
        }
      }}
    />
  );
}
